import { SlideCheckModal } from '@bilibili-maoer/prelude'
import { SlideCheckBarProps } from '@bilibili-maoer/prelude/lib/account/components/captcha/slide-check-bar'

import { Dialog, GlobalStyles, css } from '@mui/material'
import { match } from 'ts-pattern'

import { falsy, truthy } from '~/shared/utils/constant'

export interface SlideCheckDialogProps {
  open: boolean
  colorMode: 'light' | 'dark'
  onSuccess: SlideCheckBarProps['callback']
  onClose: () => void
}

const stylesFixSlideCheckModal = css`
  @media screen and (max-width: 370px) {
    .prelude-slide-check-modal {
      width: 280px;
    }
  }
`

export const SlideCheckDialog = (props: SlideCheckDialogProps) => (
  <Dialog open={props.open}>
    <GlobalStyles styles={stylesFixSlideCheckModal} />
    <SlideCheckModal
      darkMode={match(props.colorMode).with('dark', truthy).with('light', falsy).exhaustive()}
      scene="nc_message"
      onSuccess={props.onSuccess}
      onClose={props.onClose}
    />
  </Dialog>
)
